module.exports = __webpack_public_path__ + "static/media/Golos_Text_DemiBold.6a87bd4d.woff2";